var mainSlider = $('.main-slider');

if (mainSlider.length){
    mainSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
    });
}
